"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = exports.Benefit = void 0;
var _mui = require("@ori-ui/mui");
const Root = exports.Root = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'grid',
  gap: theme.spacing(3)
}));
const Benefit = exports.Benefit = (0, _mui.styled)('div')(({
  theme
}) => ({
  alignItems: 'center',
  display: 'flex',
  marginBottom: theme.spacing(2),
  [theme.breakpoints.up('md')]: {
    marginBottom: theme.spacing(1)
  },
  '&:before': {
    background: 'currentColor',
    borderRadius: '50%',
    content: '""',
    display: 'inline-block',
    height: 3,
    marginRight: theme.spacing(3),
    width: 3
  },
  '&:last-child': {
    marginBottom: 0
  },
  '&:empty': {
    display: 'none'
  }
}));
